import { render, staticRenderFns } from "./MoreGames.vue?vue&type=template&id=1da8e09d&scoped=true&"
import script from "./MoreGames.vue?vue&type=script&lang=js&"
export * from "./MoreGames.vue?vue&type=script&lang=js&"
import style0 from "./MoreGames.vue?vue&type=style&index=0&id=1da8e09d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da8e09d",
  null
  
)

export default component.exports